import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import Drawer from "../../components/Drawer/Drawer";
import CustomAccordion from "../../components/CustomAccordion";
import CertificateScope from "../../components/CocSummaryReportSection/CertificateScope";
import ConfirmationOfChanges from "../../components/CocSummaryReportSection/ConfirmationOfChanges";
import FscAafData from "../../components/CocSummaryReportSection/FscAafData";
import FscProductGroupList from "../../components/CocSummaryReportSection/FscProductGroupList";
import MultiSiteGroupInfo from "../../components/CocSummaryReportSection/MultiSiteGroupInfo";
import OrganizationDescription from "../../components/CocSummaryReportSection/OrganizationDescription";
import PeFcsfiRwProductCategories from "../../components/CocSummaryReportSection/PeFcsfiRwProductCategories";
import ReclaimedMaterialsInfo from "../../components/CocSummaryReportSection/ReclaimedMaterialsInfo";
import SummaryOfAssessment from "../../components/CocSummaryReportSection/SummaryOfAssessment";
import Communications from "../../components/CocSummaryReportSection/Communications";
import ProductListUpload from "../../components/CocSummaryReportSection/ProductListUpload";
import cancelIcon from "../../assets/images/cancelIcon.svg";
import "./style.css";
import {
  fetchSummaryReportData,
  getProductList,
} from "../../services/auth.api";
import { initialFormData, productListData } from "../../data/summaryReportData";
import { formatSummaryReportData } from "../../utils/commonFns";

interface SummaryReportProps {
  isDrawerOpen: boolean;
  setIsDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedId: any;
  report: any;
  selectedRowData: any;
}

const SummaryReport: React.FC<SummaryReportProps> = ({
  isDrawerOpen,
  setIsDrawerOpen,
  selectedId,
  report,
  selectedRowData
}) => {
  const [formData, setFormData] = useState<any>(null);
  const [reportData, setReportData] = useState(null);
  const [productData, setProductData] = useState(productListData);
  const [opportunityData, setOpportunityData] = useState<any>(null);
  const [activeKey, setActiveKey] = useState<string[]>([ "1", "2", "3", "4", "5", "6","7","8","9"]);

  const handleClose = () => {
    setIsDrawerOpen(false);
  };

  useEffect(() => {
    console.log(report)
    if (report) {    
      setFormData(formatSummaryReportData(report));

    }
    if (isDrawerOpen) {
      setActiveKey([ "1", "2", "3", "4", "5", "6","7","8","9", "10", "11"]);
    }
  }, [isDrawerOpen]);

  useEffect(() => {
    const fetchData = async () => {
      if (isDrawerOpen) {
        try {
          const summaryData = await fetchSummaryReportData(report.id);
          setReportData(summaryData);

          // const opportunityinfo = await getProductList(selectedRowData.opportunityId);
          // setOpportunityData(opportunityinfo);
          // console.log("Product List:", opportunityData);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };

    fetchData();
  }, [isDrawerOpen, selectedId, selectedRowData, setOpportunityData, report]);

  const handleSectionClick = (sectionKey: string) => {
    setActiveKey((prevActiveKey) => {
      console.log(prevActiveKey, "prevActiveKey::");
      // if (sectionKey === "4" || sectionKey === "5") {
      //   console.log(prevActiveKey, "prevActiveKey::", sectionKey);
      //   if (prevActiveKey.includes(sectionKey)) {
      //     console.log(prevActiveKey, "prevActiveKey::");

      //     return prevActiveKey.filter((key) => key !== sectionKey);
      //   } else {
      //     console.log(prevActiveKey, "prevActiveKey::");

      //     return prevActiveKey
      //       .filter((key) => key !== (sectionKey === "4" ? "5" : "4"))
      //       .concat(sectionKey);
      //   }
      // }
      if (prevActiveKey.includes(sectionKey)) {
        console.log(prevActiveKey, "prevActiveKey::");
        return prevActiveKey.filter((key) => key !== sectionKey);
      } else {
        console.log(prevActiveKey, "prevActiveKey::");
        return [...prevActiveKey, sectionKey];
      }
    });
  };

  const sections = [
    {
      key: "1",
      title: "Section 1: Organization Description",
      data: <OrganizationDescription formData={formData} setFormData={setFormData} />,
    },
    {
      key: "2",
      title: "Section 2: Confirmation of Changes",
      data: <ConfirmationOfChanges formData={formData} setFormData={setFormData} />,
    },
    {
      key: "3",
      title: "Section 3: Certificate Scope",
      data: <CertificateScope formData={formData} setFormData={setFormData} rowData={selectedRowData} />,
    },
    {
      key: "4",
      title: "Section 4: FSC Product Group List",
      data: <FscProductGroupList formData={formData} setFormData={setFormData} productData={productData} rowData={selectedRowData}/>,
    },
    {
      key: "5",
      title: "Product Categories List",
      data: <ProductListUpload report={report} formData={formData} setFormData={setFormData} rowData={selectedRowData} />,
    },
    {
      key: "6",
      title: "Section 5: PEFC/SFI/RW Product Categories",
      data: <PeFcsfiRwProductCategories formData={formData} setFormData={setFormData} />,
    },
    {
      key: "7",
      title: "Section 6: Reclaimed Materials Information",
      data: <ReclaimedMaterialsInfo formData={formData} setFormData={setFormData} />,
    },
    {
      key: "8",
      title: "Section 7: Multi-Site / Group Information",
      data: <MultiSiteGroupInfo formData={formData} setFormData={setFormData} />,
    },
    {
      key: "9",
      title: "Section 8: FSC AAF Data",
      data: <FscAafData formData={formData} setFormData={setFormData} />,
    },
    {
      key: "10",
      title: "Section 9: Summary of Assessment",
      data: <SummaryOfAssessment formData={formData} setFormData={setFormData} />,
    },
    {
      key: "11",
      title: "Communications",
      data: <Communications report={report} formData={formData} setFormData={setFormData} />,
    },
  ];

  return (
    <div className="text-center">
      <Drawer
        isOpen={isDrawerOpen}
        onClose={handleClose}
        title={"FSC CoC Summary Report"}
        subtitle={`${report?.Name}`}
      >
        {sections.map((section) => (
          <CustomAccordion
            key={section.key}
            title={section.title}
            data={section.data}
            eventKey={section.key}
            isActive={activeKey.includes(section.key)}
            onClick={() => handleSectionClick(section.key)}
          />
        ))}

        <div className="d-flex justify-content-end">
          <Button
            className="px-5 py-2 rounded-pill cancel-btn"
            onClick={handleClose}
          >
            <img src={cancelIcon} alt="Close Icon" className="cancel-icon" />
            Close
          </Button>
        </div>
      </Drawer>
    </div>
  );
};

export default SummaryReport;
